"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _util = require("lodash/util");

var _default = {
  active: false,
  badges: [],
  brand: {
    brandID: 0,
    name: (0, _util.stubString)(),
    slug: (0, _util.stubString)()
  },
  contents: {
    ingredients: {
      title: null,
      text: null
    },
    alcohol: {
      title: null,
      text: null
    }
  },
  description: (0, _util.stubString)(),
  id: (0, _util.stubString)(),
  isPromo: false,
  manufacturer: (0, _util.stubString)(),
  measurementUnit: 0,
  medias: {
    small: (0, _util.stubString)(),
    large: (0, _util.stubString)(),
    xl: (0, _util.stubString)()
  },
  name: (0, _util.stubString)(),
  oldPrice: 0,
  price: 0,
  priceMeasurementUnit: 0,
  priceUnit: 0,
  images: [],
  promo: (0, _util.stubString)(),
  slug: (0, _util.stubString)(),
  relatedProducts: [],
  tags: [{
    name: (0, _util.stubString)(),
    slug: (0, _util.stubString)(),
    generic: false,
    pos: 0,
    group: (0, _util.stubString)()
  }],
  unitQuantity: 0
};
exports.default = _default;